import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import supplierService from './supplierService';
import { toast } from 'react-toastify';

const initialState = {
  items: [],
  total: 0,
  page: 1,
  limit: 50,
  loading: false,
  error: null,
};

export const fetchSuppliers = createAsyncThunk('supplier/list', async (params, thunkAPI) => {
  try {
    return await supplierService.list(params);
  } catch (err) {
    const msg = err.response?.data?.message || err.message || 'Error listando proveedores';
    toast.error(msg);
    return thunkAPI.rejectWithValue(msg);
  }
});

export const createSupplier = createAsyncThunk('supplier/create', async (data, thunkAPI) => {
  try {
    const res = await supplierService.create(data);
    toast.success('Proveedor creado');
    return res;
  } catch (err) {
    const msg = err.response?.data?.message || err.message || 'Error creando proveedor';
    toast.error(msg);
    return thunkAPI.rejectWithValue(msg);
  }
});

export const updateSupplier = createAsyncThunk('supplier/update', async ({ id, data }, thunkAPI) => {
  try {
    const res = await supplierService.update(id, data);
    toast.success('Proveedor actualizado');
    return res;
  } catch (err) {
    const msg = err.response?.data?.message || err.message || 'Error actualizando proveedor';
    toast.error(msg);
    return thunkAPI.rejectWithValue(msg);
  }
});

export const removeSupplier = createAsyncThunk('supplier/remove', async (id, thunkAPI) => {
  try {
    await supplierService.remove(id);
    toast.success('Proveedor eliminado');
    return id;
  } catch (err) {
    const msg = err.response?.data?.message || err.message || 'Error eliminando proveedor';
    toast.error(msg);
    return thunkAPI.rejectWithValue(msg);
  }
});

const supplierSlice = createSlice({
  name: 'supplier',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSuppliers.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchSuppliers.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.items || [];
        state.total = action.payload.total || 0;
        state.page = action.payload.page || 1;
        state.limit = action.payload.limit || 50;
      })
      .addCase(fetchSuppliers.rejected, (state, action) => { state.loading = false; state.error = action.payload; })

      .addCase(createSupplier.fulfilled, (state, action) => {
        state.items.unshift(action.payload);
        state.total += 1;
      })

      .addCase(updateSupplier.fulfilled, (state, action) => {
        const idx = state.items.findIndex(s => s._id === action.payload._id);
        if (idx !== -1) state.items[idx] = action.payload;
      })

      .addCase(removeSupplier.fulfilled, (state, action) => {
        state.items = state.items.filter(s => s._id !== action.payload);
        state.total = Math.max(0, state.total - 1);
      });
  }
});

export const { reset } = supplierSlice.actions;
export default supplierSlice.reducer;
